// extracted by mini-css-extract-plugin
export default {"text":"c-b_es","text_colorGray":"c-b_et","text_colorDanger":"c-b_eu","text_colorCharming":"c-b_ev","text_fontSizeSm":"c-b_ew","text_textAlignCenter":"c-b_ex"};